import { usePermissao } from "@/contexts/autorizacao/permissao";
import { TIPO_INSPECAO } from "@/contexts/cadastro/estabelecimento";
import { useRelatorioAM } from "@/contexts/fiscalizacao/relatorioAM/hooks/useRelatorioAM";
import { PaginaRelatorioAM } from "@/contexts/fiscalizacao/relatorioAM/model/PaginaRelatorioAM";
import { STATUS_RAM } from "@/contexts/fiscalizacao/relatorioAM/model/STATUS_RAM";
import { useNetworkStatus } from "@/shared/hooks/useNetworkStatus";
import {
  EyeOutlined,
  FileAddOutlined,
  FileExclamationOutlined,
  FormOutlined,
} from "@ant-design/icons";
import { Button, List, Space, Tooltip, Typography } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router";

export function ItemListPlanoAcaoRAM({
  item,
}: {
  item: PaginaRelatorioAM["content"][number];
}) {
  const { isOnline } = useNetworkStatus();
  const { hasEnabledPermissao } = usePermissao();
  const navigate = useNavigate();
  const { canMakePlanoAcao, canMakeParecer, canViewPlanoAcao } =
    useRelatorioAM();

  const redirectToView = () => {
    navigate(`/RAM/plano-acao/visualizar/${item.id}`);
  };

  const redirectToPlanoAcao = () => {
    navigate(`/RAM/plano-acao/novo/${item.id}`);
  };

  const redirectToParecer = () => {
    navigate(`/RAM/plano-acao/parecer/${item.id}`);
  };

  const redirectToRemocaoParecer = () => {
    navigate(`/RAM/plano-acao/parecer/remover/${item.id}`);
  };

  const enabledPlanoAcao = canMakePlanoAcao(
    item.formulario?.classificacao,
    item.estabelecimento?.id
  );

  const enabledParecer = canMakeParecer(
    item.formulario?.tipoFormulario,
    item.estabelecimento?.id
  );

  const enabledView = canViewPlanoAcao(
    item.formulario?.classificacao,
    item.estabelecimento?.id
  );

  return (
    <>
      <List.Item
        extra={
          <Space>
            <Typography.Text type="secondary">
              {STATUS_RAM[item.situacao]}
            </Typography.Text>

            {enabledPlanoAcao && (
              <Tooltip title="Plano de Ação" destroyOnHidden>
                <Button
                  size="small"
                  icon={<FormOutlined />}
                  onClick={redirectToPlanoAcao}
                  disabled={
                    !isOnline ||
                    item.situacao === "CANCELADO" ||
                    item.situacao === "FINALIZADO" ||
                    !hasEnabledPermissao("RAM_PLANO_ACAO_CRIAR")
                  }
                />
              </Tooltip>
            )}

            {enabledParecer && (
              <Tooltip title="Adicionar Parecer">
                <Button
                  size="small"
                  icon={<FileAddOutlined />}
                  onClick={redirectToParecer}
                  disabled={
                    !isOnline ||
                    item.situacao === "CANCELADO" ||
                    item.situacao === "FINALIZADO" ||
                    !hasEnabledPermissao("RAM_PLANO_ACAO_PARECER_CRIAR")
                  }
                />
              </Tooltip>
            )}

            {enabledParecer && (
              <Tooltip title="Remover Parecer">
                <Button
                  size="small"
                  danger
                  icon={<FileExclamationOutlined />}
                  onClick={redirectToRemocaoParecer}
                  disabled={
                    !isOnline ||
                    item.situacao === "CANCELADO" ||
                    item.situacao === "FINALIZADO" ||
                    !hasEnabledPermissao("RAM_PLANO_ACAO_PARECER_REMOVER")
                  }
                />
              </Tooltip>
            )}

            {enabledView && (
              <Tooltip title="Visualizar" destroyOnHidden>
                <Button
                  size="small"
                  icon={<EyeOutlined />}
                  onClick={redirectToView}
                  disabled={
                    !isOnline ||
                    item.situacao === "CANCELADO" ||
                    !hasEnabledPermissao("RAM_PLANO_ACAO_VISUALIZAR")
                  }
                />
              </Tooltip>
            )}
          </Space>
        }
      >
        <List.Item.Meta
          title={
            <Typography.Text
              strong
              style={{
                opacity: item.situacao === "CANCELADO" ? 0.6 : 1,
              }}
            >
              RAM {item.id}
            </Typography.Text>
          }
          description={
            <Typography.Text
              style={{
                fontSize: 12,
                color: "#8c8c8c",
              }}
            >
              Estabelecimento: {item.estabelecimento?.numeroInspecao}-
              {item.estabelecimento &&
                TIPO_INSPECAO[item.estabelecimento.tipoInspecao]}
              -{item.estabelecimento?.nome} <br />
              Data Preenchimento:{" "}
              {item.dataMonitoria
                ? dayjs(item.dataMonitoria).format("DD/MM/YYYY")
                : "-"}
            </Typography.Text>
          }
        />
      </List.Item>
    </>
  );
}
